export const debounce = (fn: () => void, timeout = 500) => {
  let timer: ReturnType<typeof setTimeout>
  return (...args: []) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(this, args)
    }, timeout)
  }
}
